import { Config, EntityDialog, ErrorHandling, HtmlContentEditor, getjQuery } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { siteLanguageList } from "./Helpers/LanguageList";

Config.rootNamespaces.push('Poisum_Portal');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
gridDefaults.useCssVars = false;
gridDefaults.useLegacyUI = true;

let $ = getjQuery();
if ($?.fn?.colorbox) {
    $.fn.colorbox.settings.maxWidth = "95%";
    $.fn.colorbox.settings.maxHeight = "95%";
}

const SESSION_TIMEOUT_WARNING = 30 * 60 * 1000 - 30 * 1000; // 29 minutes and 30 seconds
const SESSION_TIMEOUT_REDIRECT = 30 * 60 * 1000; // 30 minutes

let timeoutWarningTimer: number | undefined;
let timeoutRedirectTimer: number | undefined;

function startSessionTimeoutCountdown() {
    // Clear previous timers
    clearTimeout(timeoutWarningTimer);
    clearTimeout(timeoutRedirectTimer);

    // Set warning timer to trigger 30 seconds before the session expires
    timeoutWarningTimer = window.setTimeout(() => {
        showTimeoutWarning();
    }, SESSION_TIMEOUT_WARNING);

    // Set redirect timer to trigger after 30 minutes
    timeoutRedirectTimer = window.setTimeout(() => {
        redirectToLogin();
    }, SESSION_TIMEOUT_REDIRECT);
}

function showTimeoutWarning() {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.id = 'session-warning-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'; // Dimmed background
    overlay.style.zIndex = '1050'; // Ensure it's behind the dialog
    document.body.appendChild(overlay);

    // Create dialog
    const dialog = document.createElement('div');
    dialog.id = 'session-warning-dialog';
    dialog.style.position = 'fixed';
    dialog.style.top = '50%';
    dialog.style.left = '50%';
    dialog.style.transform = 'translate(-50%, -50%)';
    dialog.style.padding = '20px';
    dialog.style.backgroundColor = '#fff';
    dialog.style.border = '1px solid #ccc';
    dialog.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
    dialog.style.borderRadius = '8px';
    dialog.style.zIndex = '1051'; // Ensure it's in front of other elements

    // Title
    const title = document.createElement('div');
    title.textContent = 'Timeout Warning';
    title.style.backgroundColor = '#f0f0f0'; // Light grey background
    title.style.padding = '10px';
    title.style.borderRadius = '8px 8px 0 0'; // Border radius for top corners
    title.style.fontWeight = 'bold';
    title.style.textAlign = 'center';
    dialog.appendChild(title);

    // Message
    const message = document.createElement('p');
    message.innerHTML = `Your session is about to timeout, do you want to continue your session ? <br><strong id="countdown-timer" style = "color: red;" > </strong>;`
    message.style.textAlign = 'center';
    dialog.appendChild(message);

    // OK Button
    const okButton = document.createElement('button');
    okButton.textContent = 'Stay Signed In';
    okButton.style.backgroundColor = '#007bff'; // Blue
    okButton.style.color = '#fff'; // White
    okButton.style.border = 'none';
    okButton.style.padding = '6px 20px';
    okButton.style.borderRadius = '4px';
    okButton.style.cursor = 'pointer';
    okButton.style.fontSize = '16px';
    okButton.style.display = 'block';
    okButton.style.margin = '10px auto';
    okButton.onclick = () => {
        hideWarningDialog();
        startSessionTimeoutCountdown(); // Restart countdown on user action
    };
    dialog.appendChild(okButton);

    document.body.appendChild(dialog);

    let secondsLeft = Math.floor((SESSION_TIMEOUT_WARNING - 1000) / 1000); // Countdown time
    const countdownInterval = setInterval(() => {
        if (secondsLeft <= 0) {
            clearInterval(countdownInterval);
            hideWarningDialog();
            redirectToLogin();
        } else {
            const countdownElement = document.getElementById('countdown-timer');
            if (countdownElement) {
                countdownElement.textContent = formatTime(secondsLeft);
            }
            secondsLeft--;
        }
    }, 1000);
}

function hideWarningDialog() {
    const dialog = document.getElementById('session-warning-dialog');
    const overlay = document.getElementById('session-warning-overlay');
    if (dialog) {
        document.body.removeChild(dialog);
    }
    if (overlay) {
        document.body.removeChild(overlay);
    }
}

function redirectToLogin() {
    window.location.href = '/Account/Login'; // Update to your login page URL
}

function formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${secs} second${secs !== 1 ? 's' : ''}`;
}

document.addEventListener('mousemove', startSessionTimeoutCountdown);
document.addEventListener('keypress', startSessionTimeoutCountdown);

// Start the timeout countdown when the script loads
startSessionTimeoutCountdown();

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);